import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServiceCards from './components/ServiceCards';
import PartsInquiry from './components/PartsInquiry';
import BatteryRoadside from './components/BatteryRoadside';
import ServiceAreas from './components/ServiceAreas';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import MobileBottomBar from './components/MobileBottomBar';

export default function Home() {
  return (
    <div className="min-h-screen bg-brand-dark font-sans antialiased">
      <Navbar />
      <main>
        <HeroSection />
        <ServiceCards />
        <PartsInquiry />
        <BatteryRoadside />
        <ServiceAreas />
        <TrustSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileBottomBar />
    </div>
  );
}